import styled from 'styled-components';
import theme from 'src/styles/theme';
import { Tonality } from '@dsny/dsny-component-library';
import { Delete } from '@dsny/dsny-component-library/icons';

interface Props {
  children: React.ReactNode;
  selectedItemIndex: number;
  value: { description: string } | string;
  onChange?: () => void;
  onClick?: () => void;
}

interface CheckBoxProps {
  isDisabled: boolean;
}

export const ComboboxOptionWrapper = styled(Tonality.ComboboxOption)<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;

  &:hover {
    background: ${theme.colors.neutralW100};
  }

  &:nth-child(${({ selectedItemIndex }) => selectedItemIndex}) {
    background: ${theme.colors.mtr100};
  }
`;

export const RowItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  overflow: hidden;
`;

export const ItemWrapper = styled.div<CheckBoxProps>`
  font-size: 14px;
  line-height: 19px;
  color: ${({ isDisabled }) =>
    isDisabled ? theme.colors.neutralW70 : theme.colors.neutralW40};
  align-self: center;
  margin-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  max-width: calc(100% - 40px);
`;

export const DeleteIconWrapper = styled(Delete)`
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.neutralW40};
  cursor: pointer;
  border: none;
  padding: 4px;
  margin-left: auto;
  min-width: 24px;

  &:hover {
    background-color: ${theme.colors.white0};
  }
`;

export const DeleteButton = styled.div`
  font-size: 14px;
  line-height: 19px;
  color: ${theme.colors.neutralW40};
  align-self: center;
`;

export const CheckboxStyles = {
  borderColor: theme.colors.neutralW70,
  marginRight: '8px',
};

export const NoResultMessage = styled.span`
  padding-top: 8px;
  padding-bottom: 16px;
  width: 100%;
  color: ${theme.colors.neutralW40};
  font-size: 14px;
`;

export const CreateArtistWrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 19px;
  color: ${theme.colors.neutralW40};
  padding: 8px 16px;
  width: 100%;
  cursor: pointer;

  &:hover {
    background: ${theme.colors.neutralW100};
  }
`;

export const EnteredArtist = styled.div`
  font-weight: 700;
`;

export const InlineErrorMessage = styled.p`
  color: ${theme.colors.error60};
  font-size: 12px;
  margin-top: 8px;
`;
